import { Flex, Text } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { useLogger } from "@/hooks/useLogger"
import { useTranslation } from "@/hooks/useTranslation"
import { CloudUploadOutlined } from "@/icons"
import { Heading } from "@/molecules/Heading"
import { LinkButton } from "@/molecules/LinkButton"
import { TYPE_DEPLOY } from "@/pages/DeploymentsPage/const"

import styles from "./ListIntegrationsMenu.module.scss"

export const DeploySensorBanner = () => {
  const { logger, EVENTS } = useLogger()
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.deploySensor"
  })

  return (
    <Flex vertical gap={16} className={styles.deploySensor}>
      <Flex gap={8} align="center">
        <Heading
          level={5}
          title={t("title")}
          classes={{ title: styles.text }}
        />
        <CloudUploadOutlined className={styles.icon} />
      </Flex>
      <Text>{t("text")}</Text>
      <LinkButton
        block
        to={`/${NAMES_ROUTES.DEPLOYMENTS.ROOT}/${NAMES_ROUTES.DEPLOYMENTS.NEW_DEPLOYMENT}/${TYPE_DEPLOY.KUBERNETES}`}
        onClick={() =>
          logger.info(EVENTS.ANALYTIC_EVENTS.INTEGRATIONS.DEPLOY_SENSOR_CLICKED)
        }
      >
        {t("action")}
      </LinkButton>
    </Flex>
  )
}
